var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FilterTypeDate',{attrs:{"fromType":"reserveDateFrom","toType":"reserveDateTo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }